module.exports = __webpack_public_path__ + "assets/shopping_cart_page_empty_state-f25830.svg";